// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-select__option {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 50px;
}
.conn-form-select__option_disabled, .conn-form-select__description {
  color: var(--g-color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/components/Select/Select.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;AAAR;AAGI;EAEI,oCAAA;AAFR","sourcesContent":[".conn-form-select__option {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  height: 50px;\n}\n.conn-form-select__option_disabled, .conn-form-select__description {\n  color: var(--g-color-text-secondary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
